import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/siteData";

export default function Footer() {
  const column1 = categories.slice(0, 5);
  const column2 = categories.slice(5, 10);
  const column3 = categories.slice(10, 14);

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="text-xl font-heading font-bold tracking-tight mb-4 block hover:opacity-80 transition-opacity cursor-pointer">
              superbuyspreadsheet<span className="text-accent-500">.bar</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mb-6 max-w-sm">
              Your ultimate resource for the Superbuy Spreadsheet — trusted product links, verified sellers, and expert buying guides for international shoppers.
            </p>
            <Link
              to="/article/superbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
            >
              Read Our Complete Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">Categories</h4>
            <ul className="space-y-2.5">
              {column1.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {column2.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {column3.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-700/50">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="w-20 h-16 rounded-xl overflow-hidden bg-foreground-800 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20of%20neatly%20organized%20product%20cards%20and%20a%20small%20notebook%20on%20a%20warm%20cream%20desk%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20lifestyle%20composition%2C%20clean%20modern%20aesthetic%2C%20subtle%20warm%20tones%2C%20organized%20workspace%20feel&width=200&height=160&seq=footer-thumb-v2&orientation=landscape"
                  alt="Superbuy Spreadsheet"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-base font-heading italic text-foreground-300 leading-snug">
                  &copy; {new Date().getFullYear()} superbuyspreadsheet.bar
                </p>
                <p className="text-xs text-foreground-400 mt-0.5">All rights reserved.</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <span className="text-xs text-foreground-300">Stay updated with the latest links:</span>
              <form
                data-readdy-form
                action="https://readdy.ai/api/form/d8rul2rf81iibef4biag"
                method="POST"
                className="flex items-center gap-2"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Your email address"
                  required
                  className="w-48 md:w-56 px-4 py-2.5 rounded-lg bg-foreground-800 border border-foreground-600 text-sm text-background-50 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500 transition-colors"
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 rounded-lg bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Subscribe
                  <i className="ri-arrow-right-line ml-1.5 w-3.5 h-3.5 inline-flex items-center justify-center"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}